import { overviewPages } from '@components/_rolex/FamilyOverview/filterOptions'
import { MultipleItemResponse } from '.'
import { RolexProduct } from './models/RolexProduct'
import { fetchContent } from './fetchContent'

const getCacheKey = (parts: any[]) => parts.filter(t => t).join('|')
let cache = {}

const inCache = (cache, key) => typeof cache[key] !== 'undefined'

type RolexItemsArgs = {
  language: string
  family?: string
  style?: string[]
  material?: string[]
  size?: string[]
  dial?: string[]
  page?: number
}

const ITEMS_PER_PAGE = 18

export const getRolexProducts = async (
  args: RolexItemsArgs
): Promise<MultipleItemResponse<RolexProduct>> => {
  const { language, family, style, material, size, dial, page = 1 } = args
  const key = getCacheKey(['RolexItems', language, family, style, material, size, dial, page])
  const actualPage = page > 0 ? page - 1 : 0
  if (inCache(cache, key)) {
    if (process.env.NODE_ENV === 'development') {
      console.info(`${key} returned from from cache`)
    }
    return cache[key]
  } else {
    let params = {
      limit: ITEMS_PER_PAGE,
      skip: actualPage * ITEMS_PER_PAGE,
      includeTotalCount: 'true',
      elements: [
        'rolex_family',
        'url_slug',
        'title',
        'short_description',
        'preview_image_desktop',
        'preview_image_mobile',
        'festive_selection_image',
        'priority_within_family'
      ],
      'system.type[in]': ['rolex_product'],
      language
    }

    // Skip families that are overviews, because they aren't taxonomies in Kontent,
    // so we can't filter by them
    if (family && !overviewPages.includes(family)) {
      // Replace all dashes (-) with underscores (codenames in Kontent cant have a dash)
      params['elements.rolex_family[any]'] = [family.replace(/-/g, '_')]
      // items.anyFilter('elements.rolex_family', [family.replace(/-/g, '_')])
      params['order'] = 'elements.priority_within_family[desc]'
      // items.orderParameter('elements.order_within_family', SortOrder.desc)
    } else {
      // items.orderParameter('elements.order_overall', SortOrder.desc)
      params['order'] = 'elements.order_overall[desc]'
    }

    if (style && style.length) {
      params['elements.rolex_style[any]'] = style.map(s => s.replace(/-/g, '_'))
      // items.anyFilter(
      //   'elements.rolex_style',
      //   style.map(s => s.replace(/-/g, '_'))
      // )
    }
    if (material && material.length) {
      params['elements.rolex_material[any]'] = material.map(s => s.replace(/-/g, '_'))
      // items.anyFilter(
      //   'elements.rolex_material',
      //   material.map(s => s.replace(/-/g, '_'))
      // )
    }
    if (size && size.length) {
      params['elements.rolex_size[any]'] = size.map(s => s.replace(/-/g, '_'))
      // items.anyFilter(
      //   'elements.rolex_size',
      //   size.map(s => s.replace(/-/g, '_'))
      // )
    }

    if (dial && dial.length) {
      params['elements.rolex_dial[any]'] = dial.map(s => `${s.replace(/-/g, '_')}_dial`)
      // items.anyFilter(
      //   'elements.rolex_dial',
      //   dial.map(s => `${s.replace(/-/g, '_')}_dial`)
      // )
    }

    const response: MultipleItemResponse<RolexProduct> = await fetchContent({
      path: '',
      params
    })
    cache[key] = response
    return cache[key]
  }
}
